export default __webpack_public_path__ + "static/media/megane-rs-colour-4.93ba9212.jpg";